/**
 * AppShell.tsx — authenticated shell. Sidebar + Header + content slot.
 *
 * Mirrors TNSC's two-column layout. The TweaksPanel is intentionally
 * omitted in v1 — we don't ship the design tweaker yet, but the design.css
 * tokens still apply if a future user wants a navy/teal/plum theme.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from './Sidebar';
import Header from './Header';

export default function AppShell() {
	return (
		<div className="app">
			<Sidebar />
			<div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
				<Header />
				<main style={{ flex: 1, minWidth: 0 }}>
					<Outlet />
				</main>
			</div>
		</div>
	);
}
